import { render, staticRenderFns } from "./ProductionQualityInspectionDimensionDetailInput.vue?vue&type=template&id=ab44e126&scoped=true&"
import script from "./ProductionQualityInspectionDimensionDetailInput.vue?vue&type=script&lang=js&"
export * from "./ProductionQualityInspectionDimensionDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./ProductionQualityInspectionDimensionDetailInput.vue?vue&type=style&index=0&id=ab44e126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab44e126",
  null
  
)

export default component.exports